import momentJalaali from "moment-jalali";
import Loader from "react-loader-spinner";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { getServiceAccountingList, getServiceAccountingListByProductType } from "../store/api/Services";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { exportToExcel } from "../../store/api/CommonFunctions";
import DatePicker from "react-datepicker2";
import BihamtaTable from "../../Components/BihamtaTable";
import { ClipboardData, FileEarmarkExcelFill, LayerBackward, Printer, PrinterFill, Search } from "react-bootstrap-icons";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { getAllGuaranteeHolders } from "../store/api/GuaranteeApi";
import { getAllProductTypes } from "../store/api/GetAllProduct";
import { Bar, BarChart, CartesianGrid, Label, ResponsiveContainer, XAxis, YAxis } from "recharts";

const ServiceAccountingReportByProductType = () => {

    const history = useHistory();
    const dispatch = useDispatch();
    const { filterData, settings, dataList } = useSelector(state => { return { filterData: state.service.srvAccListFilters, settings: state.SystemSettingsReducer.systemSettings, dataList: state.service.srvAccListByProductType } });
    const { register, handleSubmit } = useForm();
    const [dateFilters, setDateFilters] = useState({});
    const [holders, setProductHolders] = useState([]);
    const [productTypes, setProductTypes] = useState([]);

    const [pending, setPending] = useState(false);
    const settingNames = ['ProductGrouppingType'];
    const pgType = Array.isArray(settings) && settings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(settings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "ProductName", colTitle: (pgType === 1 ? "نام محصول" : "نوع محصول"), showInMobile: true },
        // { colName: "ProductModel", colTitle: "مدل محصول" },
        // { colName: "ProductCode", colTitle: "کد محصول" },
        {colName:"ServiceCount", colTitle:"تعداد خدمت"},
        { colName: "AmountCustomerShouldPay", colTitle: "قابل پرداخت", colType: "currency" }
    ]
    function search(data) {
        const dateFrom = document.getElementsByName("DateFrom")[0].value;
        if (dateFrom !== "") {
            data.ContactDateFrom = dateFilters.DateFrom;
            data.PDateFrom = dateFrom;
        }
        const dateTo = document.getElementsByName("DateTo")[0].value;
        if (dateTo !== "") {
            data.ContactDateTo = dateFilters.DateTo;
            data.PDateTo = dateTo;
        }
        const refDateFrom = document.getElementsByName("LastRefDateFrom")[0].value;
        if (refDateFrom !== "") {
            data.LastRefDateFrom = dateFilters.LastRefDateFrom;
            data.PRefDateFrom = refDateFrom;
        }
        const refDateTo = document.getElementsByName("LastRefDateTo")[0].value;
        if (refDateTo !== "") {
            data.LastRefDateTo = dateFilters.LastRefDateTo;
            data.PRefDateTo = refDateTo;
        }
        const archiveDateFrom = document.getElementsByName("ArchiveDateFrom")[0].value;
        if (archiveDateFrom !== "") {
            data.ArchiveDateFrom = dateFilters.ArchiveDateFrom;
            data.PArchiveDateFrom = archiveDateFrom;
        }
        const archiveDateTo = document.getElementsByName("ArchiveDateTo")[0].value;
        if (archiveDateTo !== "") {
            data.ArchiveDateTo = dateFilters.ArchiveDateTo;
            data.PArchiveDateTo = archiveDateTo;
        }        
        data.Skip = 0;
        dispatch(getServiceAccountingListByProductType(data));

    }
    function toExcel() {
        const url = `api/ServiceReportsAPI/GetServiceAccountingListByProductType`;
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        setPending(true);
        exportToExcel("ServiceAccountingList", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        history.push({
            pathname: `/PrintViewer/ServiceAccountingListByProductType/${e.ctrlKey}`,
            state: {
                dataUrl: `api/ServiceReportsAPI/GetServiceAccountingListByProductType`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function rowClick(row)
    {
        dispatch(getServiceAccountingList({ProductType: row.ProductName, Take:10}));
        history.push("/Services/ServiceAccountingReport");

    }
    useEffect(() => {
        dispatch(getSystemSettings(settingNames));
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
        // getAllGuaranteeHolders("", setProductHolders);
        getAllProductTypes(setProductTypes);
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faCalculator} size="lg" />&nbsp;
                    ارزش خدمات برحسب نوع محصول
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form onSubmit={handleSubmit(search)}>
                        <Row className="rowBorder">
                            <Col md={2} className="form-group">
                                <label>تاریخ پذیرش از: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="DateFrom" value={dateFilters?.DateFrom ? momentJalaali(dateFilters.DateFrom) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, DateFrom: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ پذیرش تا: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="DateTo" value={dateFilters?.DateTo ? momentJalaali(dateFilters.DateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, DateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ انجام از: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="LastRefDateFrom" value={dateFilters?.LastRefDateFrom ? momentJalaali(dateFilters.LastRefDateFrom) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, LastRefDateFrom: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ انجام تا: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="LastRefDateTo" value={dateFilters?.LastRefDateTo ? momentJalaali(dateFilters.LastRefDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, LastRefDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ بایگانی از: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="ArchiveDateFrom" value={dateFilters?.ArchiveDateFrom ? momentJalaali(dateFilters.ArchiveDateFrom) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, ArchiveDateFrom: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ بایگانی تا: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="ArchiveDateTo" value={dateFilters?.ArchiveDateTo ? momentJalaali(dateFilters.ArchiveDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, ArchiveDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>                            
                            <Col md={2} className="form-group">
                                <label>نوع سرویس</label>
                                <Form.Control as="select" name="ServiceType" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="repair">تعمیر</option>
                                    <option value="install">نصب</option>
                                </Form.Control>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مشخصات مشتری: </label>
                                <Form.Control name="CustomerName" ref={register({})} />
                            </Col>
                            {
                                pgType === 1 ?
                                    <Fragment>
                                        <Col md={2} className="form-group">
                                            <label>نام محصول:</label>
                                            <Form.Control name="ProductName" ref={register({})} />
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>مدل محصول:</label>
                                            <Form.Control name="ProductModel" ref={register({})} defaultValue={filterData?.ProductModel ?? ""} />
                                        </Col>
                                    </Fragment> :
                                    <Fragment>
                                        {/* <Col md={2} className="form-group">
                                            <label>مارک محصول:</label>
                                            <select className="form-control" name="ProductHolder" ref={register({})} defaultValue={filterData?.HolderName ?? ""}>
                                                <option value="">انتخاب کنید</option>
                                                {Array.isArray(holders) && holders.map((item, i) => <option value={item.HolderName} key={i}>{item.HolderName}</option>)}
                                            </select>
                                        </Col> */}
                                        <Col md={2} className="form-group">
                                            <label>نوع محصول:</label>
                                            <select className="form-control" name="ProductType" ref={register({})} defaultValue={filterData?.ProductType ?? ""}>
                                                <option value="">انتخاب کنید</option>
                                                {Array.isArray(productTypes) && productTypes.map((item, i) => <option value={item.Name} key={i}>{item.Name}</option>)}
                                            </select>
                                        </Col>
                                    </Fragment>
                            }
                        </Row>
                        <Button type="submit" className="mt-1 group-Btn-large"><ClipboardData size={18} />&nbsp; خروجی گزارش </Button>
                        <Button className="mt-1 group-Btn-large" variant="secondary" onClick={printReport} ><Printer size={18}/> چاپ گزارش</Button>
                    </form>
                    <Row>
                        <Col md={4}>
                            {!pending &&
                                <div style={{ padding: 1, width: "100%", textAlign: "left", marginTop: "5px" }}>
                                    <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                                </div>}
                            {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                            <BihamtaTable columns={tableCols} reducerName="service" objectName="srvAccListByProductType" filterData={filterData} style={{ whiteSpace: "nowrap" }} maxHeight={500} className="mt-0 mb-0" rowClick={rowClick}/>
                        </Col>
                        <Col md={8}>
                            {dataList?.Data?.length > 0 &&
                                <ResponsiveContainer width="100%" height="100%" className="barChart" debounce={300}>
                                    <BarChart data={dataList.Data}>
                                        {/* <Legend align="left" verticalAlign="bottom" content ={renderLegend}/> */}
                                        <XAxis dataKey="ProductName" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} height={50} angle={-30} tickMargin={8}>
                                            <Label value="نوع محصول" offset={2} position="insideBottom" style={{ fill: "blue" }} />
                                        </XAxis>
                                        <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5}
                                            label={{ value: "تعداد", angle: 90, style: { fill: "blue" } }} />
                                        <CartesianGrid />
                                        <Bar dataKey="ServiceCount" fill="#05386b" label={{ position: 'top' }} isAnimationActive={false} />
                                    </BarChart>
                                </ResponsiveContainer>
                            }

                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>)
}
export default ServiceAccountingReportByProductType;